import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { PV_NO_ASIGNADO_MSG } from "@/lib/pvAsignado";

interface PvNoAsignadoGateProps {
  blocked: boolean;
  dialogOpen: boolean;
  onDialogOpenChange: (open: boolean) => void;
}

export function PvNoAsignadoGate({
  blocked,
  dialogOpen,
  onDialogOpenChange,
}: PvNoAsignadoGateProps) {
  return (
    <>
      {blocked && (
        <Alert variant="destructive">
          <AlertCircle />
          <AlertTitle>No se puede continuar</AlertTitle>
          <AlertDescription>{PV_NO_ASIGNADO_MSG}</AlertDescription>
        </Alert>
      )}
      <AlertDialog open={dialogOpen} onOpenChange={onDialogOpenChange}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>No se puede continuar</AlertDialogTitle>
            <AlertDialogDescription>{PV_NO_ASIGNADO_MSG}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction type="button">Entendido</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
